<template>
  <div class="dashboard">
    <div class="row">
      <div class="flex xs12 lg12">
        <GatewayList />
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 lg12">
        <GatewayDetails />
      </div>
    </div>
  </div>
</template>

<script>
import GatewayList from './GatewayList'
import GatewayDetails from './GatewayDetails'
export default {
  name: 'alerts',
  components: {
    GatewayList,
    GatewayDetails,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
